import IMAGES from "@/public/assets/img";

const professionalsLoan = {
  seoData: {
    title: "Business Loans for Doctors, CAs & Lawyers | Credlix",
    description:
      "Fuel your professional growth with tailored business loans from Credlix. Get up to ₹80 Lakh for doctors, architects, and CAs with competitive rates, no collateral, and quick approval. Apply now!",
    keywords:
      "business loans for professionals, loans for doctors, loans for chartered accountants, loans for architects, unsecured business loans, business expansion loan, Credlix business loan, professional loan, funding for clinics, finance for architecture firm, CA firm loan, Vanik Finance.",
  },
  bannerHeading: "Your Practice, Amplified​",
  subheading: "Business Loans for Professionals",
  btntext: "Funds up to ₹80 Lakh. No Foreclosure Charges after 12 months",

  digitalProfessional: {
    id: 1,
    title: "At Credlix, we believe your expertise is your greatest asset.",
    paragraphs: [
      "Our business loans for professionals are crafted to provide the financial foundation you need to elevate your practice, expand your services, and achieve your professional ambitions.",
      "Whether you're a doctor, lawyer, chartered accountant, or any other self-employed professional, our tailored financing solutions are designed to support your growth, not hold it back.",
      "In partnership with our Gold Partners, we offer real capital for real businesses, with a 100% digital process that's fast, transparent, and hassle-free.",
    ],
    highlight: [
      "At Credlix, we believe your expertise is your greatest asset.",
      "any other self-employed professional",
      "with a 100% digital process that's fast, transparent, and hassle-free.",
    ],
    image: IMAGES?.professionalsLoan.digitalAssets,
    alt: "Engineer with blueprint and crane",
  },

  professionalsTrustData: {
    title: "Why Professionals Trust Credlix for Growth",
    subtitle:
      "We understand that your time is valuable. That’s why we’ve built a financing solution that is as efficient as you are.",
    features: [
      {
        id: 1,
        icon: IMAGES.professionalsLoan.vision,
        title: "Funding for Your Vision",
        description:
          "Access up to ₹80 Lakhs to bring your growth plans to life. Whether it’s opening a new clinic, upgrading equipment, or expanding your team, our loans are your capital for progress.",
      },
      {
        id: 2,
        icon: IMAGES.professionalsLoan.rates,
        title: "Rates That Work for You",
        description:
          "Our competitive interest rates start from just 0.90% per month, ensuring that your loan is an investment in your future, not a burden.",
      },
      {
        id: 3,
        icon: IMAGES.professionalsLoan.tailored,
        title: "Tailored Repayment",
        description:
          "Flexible tenure and competitive interest rates make repayment manageable, with options from 12 to 96 months depending on lender and profile.",
      },
    ],
    cta: {
      text: "Check Your Eligibility in 2 Minutes",
      link: "/export-factoring/buyer-credit-check",
    },
  },

  advantageData: {
    title: "The Credlix Advantage: Tailored for Professionals",
    description:
      "We go beyond traditional lending. Our solutions are designed to address the specific needs of busy professionals.",
    bannerImage: IMAGES.professionalsLoan.caBanner,
    features: [
      {
        id: 1,
        icon: IMAGES.professionalsLoan.loanCollateral,
        title: "No Collateral Required",
        text: "Secure a loan of up to ₹80 Lakh without pledging your personal or professional assets.",
      },
      {
        id: 2,
        icon: IMAGES.professionalsLoan.lightning,
        title: "Lightning-Fast Digital Process",
        text: "Our 100% online application ensures you get a decision and funds in your account within 48 hours.",
      },
      {
        id: 3,
        icon: IMAGES.professionalsLoan.documentaion,
        title: "Minimal Documentation, Maximum Ease",
        text: "Say goodbye to endless paperwork. Our process requires minimal documentation so you can focus on what you do best.",
      },
    ],
  },
  
  professionData:{
    title: "Specific Benefits for Your Profession",
    professions: [
      {
        id: 1,
        bgColor: "bg-[#F0F7FF]",
        image: IMAGES.professionalsLoan.doctors,
        name: "Doctors",
        benefits: [
          "Expand Your Clinic – Open new branches to serve a wider patient base.",
          "State-of-the-Art Equipment – Invest in diagnostic tools and medical technology.",
          "Enhance Patient Care – Renovate your clinic or hire specialized staff.",
        ],
      },
      {
        id: 2,
        bgColor: "bg-[#F5FFFC]",
        image: IMAGES.professionalsLoan.CharteredAccountants,
        name: "Chartered Accountants",
        benefits: [
          "Upgrade Your Technology – Invest in new accounting software & IT infrastructure.",
          "Firm Expansion – Open new branches and expand your client base.",
          "Boost Working Capital – Cover operational costs like salaries and rent.",
        ],
      },
    ],
  },  

loanFeaturesData: {
  title: "Loan Features & Eligibility at a Glance",
  features: [
    {
      id: 0,
      label: "Feature",
      value: "Details",
    },
    {
      id: 1,
      icon: IMAGES.professionalsLoan.loanAmount,
      label: "Loan Amount :",
      value: "Up to ₹80 Lakh",
    },
    {
      id: 2,
      icon: IMAGES.professionalsLoan.interest,
      label: "Interest Rate :",
      value: "From 0.90 % per month",
    },
    {
      id: 3,
      icon: IMAGES.professionalsLoan.tenure,
      label: "Tenure :",
      value: "Up to 96 months",
    },
    {
      id: 4,
      icon: IMAGES.professionalsLoan.collateral,
      label: "Collateral :",
      value: "Not required (Unsecured Loan)",
    },
    {
      id: 5,
      icon: IMAGES.professionalsLoan.eligibility,
      label: "Eligibility :",
      value: "Self-employed professional (doctor, CA, Lawyers)",
    },
    {
      id: 6,
      icon: IMAGES.professionalsLoan.turnover,
      label: "Turnover :",
      value: "Minimum ₹50 Lakhs annually",
    },
    {
      id: 7,
      icon: IMAGES.professionalsLoan.age,
      label: "Business Age :",
      value: "Minimum 1 year",
    },
    {
      id: 8,
      icon: IMAGES.professionalsLoan.applicantAge,
      label: "Applicant Age :",
      value:
        "22 to 80 years for Doctors & CAs, 22 to 72 years for Lawyers",
    },
  ],
},


  bannerCTA: {
    title: "Ready to Accelerate? Your Journey Starts Here!",
    description:
      "Gain the speed, flexibility, and financial freedom to propel your exports globally.",
    button: {
      label: "Check Your Eligibility in 2 Minutes",
    },
  },

  FaqHead: "Frequently Asked Questions (FAQs)",
  Faq: [
    {
      id: 0,
      question: "What documents are required to apply for the loan?",
      answers: `
    <b>Required Documents for a Professional Loan</b> <br />
    To apply and obtain approval, please submit the following:
    <ul class="list-disc pl-5 mt-xsp">
      <li>Any three basic KYC documents such as Aadhaar Card, Driving License, Voter ID, Passport, NREGA Job Card, or a letter issued by the National Population Register.</li>
      <li>PAN Card</li>
      <li>Proof of professional qualification:</li>
      <li>For doctors: Medical practice certificate</li>
      <li>For chartered accountants: Certificate of Practice (COP)</li>
      <li>For lawyers: SANAD registration certificate</li>
    </ul>
  `,
    },
    {
      id: 1,
      question: "How long does the approval process take?",
      answers:
        "Our digital process is designed for speed. We aim to provide a loan decision within 48 hours of a complete application.",
    },
    {
      id: 2,
      question:
        "Can I use the loan for specific professional needs like buying new equipment or software?",
      answers:
        "Yes, our business loans are versatile and can be used for any business-related expense, including purchasing equipment, software, renovating your office, or managing working capital.",
    },
    {
      id: 3,
      question: "Are there any hidden costs?",
      answers:
        "Credlix operates with 100% transparency. All charges, including processing fees, are clearly stated upfront, with no hidden surprises.",
    },
    {
      id: 4,
      question: "Who can apply for a professional loan?",
      answers: `To apply for a professional loan, you must:
      <ul class="list-disc pl-5 mt-xsp">
        <li>Be an Indian citizen aged between 22 and 80 years</li>
        <li>Have a minimum CIBIL score of 685</li>
        <li>Additionally:</li>
      </ul>
      <ul class="list-disc pl-5 mt-xsp">
        <li>Doctors must hold a degree registered with the Medical Council</li>
        <li>Chartered Accountants (CAs) must possess a valid Certificate of Practice</li>
      </ul>`,
    },
  ],
};
export default professionalsLoan;
